<template>
  <button
    :aria-disabled="loading"
    :aria-label="loading ? 'Action is in progress, please wait.' : undefined"
    :class="[variant, getClasses ]"
    class="flex-button-content align-middle"
    @keydown.capture.enter.space="onSpaceKeydown"
  >
    <Spinner
      v-if="loading"
      :color="['primary', 'emphasis'].includes(variant) ? 'white' : 'black'"
      class="loading-spinner"
    />
    <span :class="{ invisible: loading }">
      <slot />
    </span>
  </button>
</template>

<script setup>
import { computed } from 'vue';
import Spinner from '../spinner';

const props = defineProps({
  variant: {
    type: String,
    required: false,
    default: 'primary',
    validator: (val) => ['primary', 'secondary', 'emphasis', 'link'].includes(val),
  },
  size: {
    type: String,
    required: false,
    default: undefined,
    validator: (val) => ['small'].includes(val),
  },
  expanded: Boolean,
  disabled: Boolean,
  loading: Boolean,
});
const onSpaceKeydown = (event) => {
  if (props.loading || props.disabled) {
    event.preventDefault();
    event.stopPropagation();
  }
};
const getClasses = computed(() => {
  if (props.variant !== 'link') {
    return {
      disabled: props.loading || props.disabled,
      'button-small': props.size === 'small',
      expanded: props.expanded,
      button: true,
    };
  }
  return '';
});
</script>
<style lang="scss" scoped>

.flex-button-content {
  display: inline-flex;

  &.disabled {
    pointer-events: none;
  }

  .loading-spinner {
    position: absolute;
  }
}
</style>
